import { createAsyncThunk } from '@reduxjs/toolkit';
import { submitTransferPartnerAPI } from '@services/WebApiService';

async function submitByRegion({ accessToken, reset, result }) {
  if (result.submitSuccess || !result.validateResult?.validationSuccess) return { ...result };
  try {
    const transferResult = await submitTransferPartnerAPI({
      accessToken,
      reset,
      parameters: result.parameters,
      region: result.region,
    });

    return { ...result, submitSuccess: transferResult.status === 200, submitError: undefined };
  } catch (error) {
    console.error(error);
    let submitError;
    if (error.response?.data?.message) submitError = error.response?.data?.message;
    else if (error.response?.status) submitError = `Error ${error.response?.status}`;
    else submitError = 'Something went wrong when validating the request.';
    return { ...result, submitSuccess: false, submitError };
  }
}

const submitTransferAggregatePartnerAsync = createAsyncThunk(
  'TransferPartner/submitTransferAggregatePartner',
  async ({ accessToken, reset }, thunkAPI) => {
    try {
      const currState =
        thunkAPI.getState()?.transferAggregatePartnerState.transferAggregatePartnerState;

      const promises = [];
      currState.results.forEach((result) => {
        const promise = submitByRegion({
          accessToken,
          reset,
          result,
        });
        promises.push(promise);
      });

      const results = await Promise.all(promises);
      return {
        results,
        error: null,
        // error: results
        //   .filter((r) => !!r.submitError)
        //   .map((r) => (r.region ? `${r.region.toUpperCase()}: ` : '') + r.submitError),
      };
    } catch (error) {
      console.error(error);
      if (error.response?.data?.message) return { error: error.response?.data?.message };
      if (error.response?.status) return { error: `Error ${error.response?.status}` };
      return { error: 'Something went wrong when processing your request' };
    }
  }
);

const { pending, fulfilled, rejected } = submitTransferAggregatePartnerAsync;

const submitTransferAggregatePartnerExtraReducers = {
  [pending]: (state) => {
    state.transferAggregatePartnerState.errorMessage = null;
    state.transferAggregatePartnerState.isSubmitting = true;
  },
  [rejected]: (state) => {
    state.transferAggregatePartnerState.isSubmitting = false;
  },
  [fulfilled]: (state, action) => {
    state.transferAggregatePartnerState.isSubmitting = false;
    state.transferAggregatePartnerState.results = action?.payload?.results || null;
    state.transferAggregatePartnerState.errorMessage = action?.payload?.error?.length
      ? action?.payload?.error
      : null;
  },
};

export { submitTransferAggregatePartnerAsync, submitTransferAggregatePartnerExtraReducers };
